// Deshabilitar clic derecho
document.addEventListener('contextmenu', function(e) {
  e.preventDefault();
  return false;
});

// Deshabilitar arrastrar imágenes
document.addEventListener('dragstart', function(e) {
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
    return false;
  }
});

// Deshabilitar selección de texto e imágenes
document.body.style.userSelect = 'none';
document.body.style.webkitUserSelect = 'none';
